// Suppress ResizeObserver errors globally
(function() {
  // Suppress the error overlay for ResizeObserver
  const debounce = (callback, delay) => {
    let tid;
    return function (...args) {
      const ctx = self;
      tid && clearTimeout(tid);
      tid = setTimeout(() => {
        callback.apply(ctx, args);
      }, delay);
    };
  };

  const _ = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ {
    constructor(callback) {
      callback = debounce(callback, 20);
      super(callback);
    }
  };

  // TEMPORARILY DISABLED - Error suppression commented out to reveal React errors
  // const originalError = console.error;
  // console.error = function(...args) {
  //   const errorString = String(args[0]);
  //   if (errorString.includes('ResizeObserver loop') || 
  //       errorString.includes('ResizeObserver loop completed with undelivered notifications')) {
  //     return;
  //   }
  //   originalError.apply(console, args);
  // };

  // TEMPORARILY DISABLED - Runtime error suppression commented out
  // TEMPORARILY DISABLED
  // window.addEventListener('error', function(e) {
  //   if (e.message && (e.message.includes('ResizeObserver loop') || 
  //       e.message.includes('ResizeObserver loop completed with undelivered notifications'))) {
  //     e.stopImmediatePropagation();
  //     e.preventDefault();
  //     return false;
  //   }
  // }, true);

  // TEMPORARILY DISABLED
  // window.addEventListener('unhandledrejection', function(e) {
  //   if (e.reason && e.reason.message && 
  //       (e.reason.message.includes('ResizeObserver loop') || 
  //        e.reason.message.includes('ResizeObserver loop completed with undelivered notifications'))) {
  //     e.stopImmediatePropagation();
  //     e.preventDefault();
  //     return false;
  //   }
  // }, true);
})();

// Prevent mouse wheel scroll on number inputs globally
document.addEventListener('wheel', function(e) {
  if (e.target.type === 'number') {
    e.preventDefault();
  }
}, { passive: false });

// Also prevent on focus
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('wheel', function(e) {
    if (document.activeElement.type === 'number') {
      document.activeElement.blur();
    }
  });
});

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
